import type { StateCreator } from 'zustand';
import type { IInput } from '@/types';

export interface InputsSlice {
  inputs: IInput[];
  setInputs: (inputs: IInput[]) => void;
  updateInput: (params: { id: string; value: Record<string, unknown> }) => void;
}

export const inputsInitialState = {
  inputs: [] as IInput[],
};

export const createInputsSlice: StateCreator<
  InputsSlice,
  [],
  [],
  InputsSlice
> = (set) => ({
  ...inputsInitialState,

  setInputs: (inputs) => set({ inputs }),

  updateInput: ({ id, value }) =>
    set((state) => ({
      inputs: state.inputs.map((input) =>
        input.id === id ? ({ ...input, ...value } as IInput) : input
      ),
    })),
});
